import { render, staticRenderFns } from "./summaryBar.vue?vue&type=template&id=95544d24&scoped=true&"
var script = {}
import style0 from "./summaryBar.vue?vue&type=style&index=0&id=95544d24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95544d24",
  null
  
)

export default component.exports